// Action types for redux

// This action is for updating a field inside the config object
export const UPDATE_FIELD = "UPDATE_FIELD";
export const SET_CONFIG = "SET_CONFIG";
export const RESET_CONFIG = "RESET_CONFIG";
export const RESET_FILES = "RESET_FILES";

// For updating the files array
export const UPDATE_FILE = "UPDATE_FILE";

// For updating a generic state attribute
export const UPDATE_ATTRIBUTE = "UPDATE_ATTRIBUTE";



// WEBPACK FOOTER //
// ./src/constants/reduxActionTypes.js